import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import ContentsHistory from './ContentsHistory';
import NoticeItem from './NoticeItem';
import Pagination from '../Common/Pagination';
import { history } from '../../helpers';
import { roles } from '../../constants';
import { boardService, boardInfoService } from '../../services';
import { alertActions } from '../../modules/alert';

class NoticeMng extends Component {
    mounted = true;
    constructor(props) {
        super(props);
        const { location, myInfo, mySite } = props;
        const isUserRole = myInfo.myRole === roles.userRole;

        if (!location.state) history.goBack();
        this.state = {
            siteID: mySite.mySiteID,
            userID: myInfo.userID,
            boardInfo: null,
            boardTypeCode: location.state.boardTypeCode, // BK001(통합 컨텐츠 관리), BK002(공지사항 관리)
            contentsList: {
                totalCount: 0,
                currentPage: 1,     // 현재 페이지
                totalPage: 1,       // 전체 페이지수 totalCount/pageCount
                start: 1,           // 화면에 보이는 첫번째 게시물
                end: 1,             // 화면에 보이는 마지막 게시물
                listCount: 10,      // 한화면에 보여줄 게시물수
                currentBlock: 1,    // 현재페이지블럭
                totalBlock: 1,      // 전체 페이지 블럭(전체 페이지 수와 비교하여 마지막페이지 정함)
                startPage: 1,
                endPage: 1,

                boardList: "",
            },
            isMobile: false,
        };

        this.setBoardInfo(location.state.boardTypeCode,);
        if (!isUserRole || mySite.mySiteList.length > 0) this.setStateContentsList();
    }

    componentDidMount = () => {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    };
    componentWillUnmount() {
        this.mounted = false;
        window.removeEventListener("resize", this.resize.bind(this));
    }

    resize() {
        let isMobile = (window.innerWidth < 992);
        if (isMobile !== this.state.isMobile) {
            this.setState({ isMobile: isMobile });
        }
    }

    componentDidUpdate = () => {
        const { mySite } = this.props;
        if (mySite.mySiteID && this.state.siteID !== mySite.mySiteID) {
            this.setState({
                siteID: mySite.mySiteID,
                contentsList: {
                    ...this.state.contentsList,
                    currentPage: 1,
                    listCount: 10
                }
            }, () => { this.setStateContentsList(); });
        }
    };

    stateRefresh = () => {
        this.setState({
            contentsList: {
                ...this.state.contentsList,
                currentPage: 1,
                listCount: 10
            }
        }, () => { this.setStateContentsList(); });
    };

    setBoardInfo = (boardTypeCode) => {
        boardInfoService.findBoardInfoByType(boardTypeCode)
            .then(response => {
                if (this.mounted && response.data && response.data.length > 0) {
                    this.setState({
                        boardInfo: response.data[0]
                    });
                }
            })
            .catch(this.handleErrors);
    };

    setStateContentsList = async () => {
        console.log("컨텐츠 호출");
        let formData = new FormData();
        const { siteID, contentsList, boardTypeCode } = this.state;
        formData.append('siteID', siteID);
        formData.append('currentPage', contentsList.currentPage);
        formData.append('boardTypeCode', boardTypeCode);
        formData.append('listCount', contentsList.listCount);
        boardService.findByBoard(formData)
            .then(response => {
                if (this.mounted) {
                    this.setState({
                        contentsList: response.data
                    });
                }
            })
            .catch(this.handleErrors);
    };

    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    };

    handleListCount = (e) => {
        this.setState({
            contentsList: {
                ...this.state.contentsList,
                currentPage: 1,
                listCount: e.target.value
            }
        }, () => { this.setStateContentsList(); });
    };

    getCurrentPage = (currentPage) => {
        this.setState({
            contentsList: {
                ...this.state.contentsList,
                currentPage: currentPage
            }
        }, () => { this.setStateContentsList(); });
    };


    render() {
        const { boardInfo, boardTypeCode, contentsList } = this.state;

        const colgroupList = ["15%", "70%", "15%"];
        const cellList = ["NO", "내용", "관리설정"];
        const listCounts = ["10", "20", "50"];

        return (
            <React.Fragment>
                <h2 className="s-page-tit">
                    {boardInfo && boardInfo.boardName}
                </h2>
                <div className="search-result-wrapper contents-mng s-normal-box">
                    <Row className="search-result-top">
                        <Col xs={12} sm={6} md={5} lg={4} className="contents-search-result">
                            <i>검색결과: {contentsList.totalCount}</i>
                            <i><button className="button w98-button white-button" style={{ width: this.state.isMobile ? '75px' : '98px' }} name="초기화" onClick={this.stateRefresh}><img src="/assets/images/ic-refresh.svg" alt="초기화" className="ic-refresh" />초기화</button></i>
                            <i>
                                <Link to={{ pathname: "/noticeAdd", state: { boardInfo: boardInfo } }}>
                                    <button className="button w98-button white-button" style={{ width: this.state.isMobile ? '86px' : '98px' }} name="신규등록"><img src="/assets/images/ic-register.svg" alt="" className="ic-register" />신규등록</button>
                                </Link>
                            </i>
                        </Col>
                        <Col xs={12} sm={1} md={2} lg={4}>&nbsp;</Col>
                        <Col xs={12} sm={5} md={5} lg={4} className="contents-search-count">
                            <i><ContentsHistory isMobile={this.state.isMobile} siteID={this.state.siteID} boardTypeCode={boardTypeCode} /></i>
                            <select className="input-box padding-l10" name="listCount" value={contentsList.listCount} onChange={this.handleListCount}>
                                {listCounts.map((listCount, i) => {
                                    return <option key={i} value={listCount}>{listCount}건</option>;
                                })}
                            </select>
                        </Col>
                    </Row>
                    <div style={{ overflow: "auto" }}>
                        <table style={{ width: this.state.isMobile ? '900px' : '100%' }}>
                            <colgroup>
                                {colgroupList.map((col, i) => {
                                    return <col key={i} width={col} />;
                                })}
                            </colgroup>
                            <thead className="table-head">
                                <tr>
                                    {cellList.map((cell, i) => {
                                        return <th className="table-head-cell" key={i}>{cell}</th>;
                                    })}
                                </tr>
                            </thead>
                            <tbody className="table-body">
                                {(contentsList.boardList && contentsList.boardList.length > 0)
                                    ?
                                    contentsList.boardList.map((board, i) => {
                                        return <NoticeItem key={i} no={contentsList.totalCount - (contentsList.start + i) + 1} board={board} boardInfo={boardInfo} />;
                                    })
                                    :
                                    <tr>
                                        <td className="text-align-center" colSpan={cellList.length}>
                                            <div className="" style={{ margin: '20px auto' }}>
                                                <img src={"/assets/images/ic-no-data.svg"} alt="데이터없음" /><br />
                                                데이터가 없습니다.
                                            </div>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <Pagination list={contentsList} getCurrentPage={this.getCurrentPage} />
            </React.Fragment>
        );
    }
}


function mapState(state) {
    const { userinfo, mySite } = state;
    const myInfo = userinfo.item;
    return { myInfo, mySite };
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(NoticeMng);